import api from './api';

export const listAutomationFlows = async () => {
  const { data } = await api.get('/automation-flows');
  return data;
};

export const createAutomationFlow = async (flowData) => {
  const { data } = await api.post('/automation-flows', flowData);
  return data;
};

export const updateAutomationFlow = async (id, flowData) => {
  const { data } = await api.put(`/automation-flows/${id}`, flowData);
  return data;
};

export const deleteAutomationFlow = async (id) => {
  await api.delete(`/automation-flows/${id}`);
};
